var app = angular.module('leonardo');

var LocaleRun = function() {
  var DEFAULT_VALUE = 'en';
  moment.locale(DEFAULT_VALUE);
  var timezone = jstz.determine();
  moment.tz.setDefault(timezone.name());
};

app.run([LocaleRun]);
